import React from 'react';
import { connect } from 'react-redux';
import { loginUser, setUser } from '../../actions';
import { postData } from '../../utils/request.js';
import ContentLoader from "./ContentLoader";
import Button from "../form/Button";

class Login extends React.Component {

    state = {
        email: '',
        pw: '',
        disabled: false
    };

	login = async () => {
        if (this.state.email !== '' || this.state.pw !== '') {
            this.setState({disabled: true}, async () => {
                try {
                    const response = await postData({
                        action: "currentuser.loginuser",
                        "email": this.state.email,
                        "password": this.state.pw
                    }, {}, {showError: false});
                    if (response.success) {
                        this.props.loginUser(() => {
                            this.setState({disabled: false});
                        });
                    } else {
                        this.setState({
                            error: (response.msg ? response.msg : "Bejelentkezés sikertelen!"),
                            disabled: false
                        });
                    }
                } catch (e) {
                    this.setState({
                        error: (e.msg ? e.msg : "Bejelentkezés sikertelen!"),
                        disabled: false
                    });
                }
            });
        }
	}

	render() {
        const largelogo = window.envBooqadmin.largelogo ? <span dangerouslySetInnerHTML={{__html: window.envBooqadmin.largelogo}}/> : <span><b>booq</b>admin</span>;
        const disabled = this.state.disabled;
        let content = null;
        if(this.props.user && !this.props.user.dispatch) {
            content =
                <div className="login-box-body">
                    <p className="login-box-msg">Kérem várjon!</p>
                    <ContentLoader/>
                </div>;
        } else {
            let error = null;
            if (!disabled) {
                if (this.state.error) {
                    error = <div className="alert alert-danger">{this.state.error}</div>;
                }
                if (this.props.user.id !== null && this.props.user.hasPermission && !this.props.user.hasPermission(window.envBooqadmin.loginPrivilege || "admin")) {
                    error = <div className="alert alert-danger">Nincs "{window.envBooqadmin.loginPrivilege || "admin"}" jogosultságod!</div>;
                }
            }
            content = <form className="login-box-body" onSubmit={(e) => {this.login(); e.preventDefault();}}>
                <p className="login-box-msg">Az alkalmazás használatához jelentkezz be!</p>
                {error}
                <div className="form-group has-feedback">
                    <input type="email" className="form-control" required="required" disabled={disabled} onChange={(e)=> this.setState({ email: e.target.value })} placeholder="Email" />
                    <span className="glyphicon glyphicon-envelope form-control-feedback"/>
                </div>
                <div className="form-group has-feedback">
                    <input type="password" className="form-control" required="required" disabled={disabled} onChange={(e)=> this.setState({ pw: e.target.value })} placeholder="Jelszó" />
                    <span className="glyphicon glyphicon-lock form-control-feedback"/>
                </div>
                <div className="row">
                    <div className="col-sm-6 pull-right">
                        <Button color="primary" block={true} flat="true" disabled={disabled} type="submit">Bejelentkezés</Button>
                    </div>
                </div>
            </form>;
        }
        return <div className="login-box">
            <div className="login-logo">
                <a href="#">{largelogo}</a>
            </div>
            {content}
        </div>;
	}
}

export default connect(
	(state) =>{
		return {
			user: state.app.user
		};
	},
	{
		loginUser,
        setUser
	}
)(Login);